import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

// Paleta reutilizada de los colores de marca ya usados en el sistema (#111F62 primario, #21B4E9 acento)
const COLORES = ['#111F62', '#21B4E9', '#F2A93B', '#4CAF50', '#E4572E', '#8E44AD'];

// Gráfica de barras compacta para comparar 2 o más indicadores dentro de una tarjeta de dashboard.
// datos: [{ nombre: string, valor: number }]
const MiniBarChart = ({ datos }) => {
    return (
        <ResponsiveContainer width="100%" height={150}>
            <BarChart data={datos} margin={{ top: 5, right: 10, left: -20, bottom: 5 }}>
                <XAxis dataKey="nombre" tick={{ fontSize: 11 }} interval={0} />
                <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                <Tooltip />
                <Bar dataKey="valor" radius={[4, 4, 0, 0]}>
                    {
                        datos.map((entrada, index) => (
                            <Cell key={`celda-${index}`} fill={COLORES[index % COLORES.length]} />
                        ))
                    }
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    )
}

export default MiniBarChart;
